"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _axios = _interopRequireDefault(require("axios"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const useCart = _ref => {
  let {
    cartRef,
    isLoggedIn = false
  } = _ref;
  const {
    REACT_APP_PATH
  } = process.env;
  const [cart, setCart] = (0, _react.useState)({
    _loading: true
  });
  const fetchURL = "".concat(REACT_APP_PATH, "/Micado.Shop.Web/Micado.Shop.Web.IO.Api.CartApi/GetCart.api");
  const controller = new AbortController();
  const signal = controller.signal;
  (0, _react.useEffect)(() => {
    fetchCart(signal);
    return () => {
      controller.abort();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  (0, _react.useEffect)(() => {
    if (!isLoggedIn) {
      clearInterval(cartRef === null || cartRef === void 0 ? void 0 : cartRef.current);
      return;
    }
    const interval = setInterval(() => {
      fetchCart(signal);
    }, 10000);
    cartRef.current = interval;
    return () => {
      controller.abort();
      clearInterval(cartRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn]);
  const fetchCart = async signal => {
    const cartGUID = localStorage.getItem("mco-shop-cart-guid");
    if (!cartGUID) {
      setCart({});
      return;
    }
    const headers = {};
    if (localStorage.getItem("logintoken")) {
      headers["Authorization"] = "Bearer " + localStorage.getItem("logintoken");
    }
    try {
      const response = await _axios.default.get("".concat(fetchURL, "?cartGUID=").concat(cartGUID), {
        headers,
        signal
      });
      const data = await response.data;
      localStorage.setItem("mco-shop-cart", JSON.stringify(data));
      setCart(data);
      return;
    } catch (error) {}
    setCart({});
  };
  return {
    cart,
    setCart
  };
};
var _default = exports.default = useCart;